<template>
    <section class="review-section" aria-labelledby="mail-eight-d-title">
        <div class="section-heading align-start">
            <div>
                <h2 id="mail-eight-d-title" class="subtitle-1 font-weight-bold">Compilazione 8D</h2>
                <div class="caption grey--text text--darken-1">
                    Completa il rapporto della NC {{ ncNumber }} senza lasciare questa pagina.
                </div>
            </div>
            <v-chip v-if="rows.length" small color="blue lighten-4">
                <v-icon small left>mdi-file-document-edit-outline</v-icon>
                {{ completedCount }}/{{ rows.length }} completati
            </v-chip>
        </div>

        <v-progress-linear v-if="loading" indeterminate color="primary" class="mt-4" />

        <v-alert v-else-if="errorMessage" type="warning" text dense class="mt-4 mb-0">
            <div class="d-flex flex-column flex-sm-row align-sm-center">
                <span>{{ errorMessage }}</span>
                <v-spacer />
                <v-btn small text color="warning" class="mt-2 mt-sm-0" @click="refreshRows">
                    <v-icon small left>mdi-refresh</v-icon>Riprova
                </v-btn>
            </div>
        </v-alert>

        <v-alert v-else-if="!rows.length" type="info" text dense class="mt-4 mb-0">
            La NC è stata creata, ma Sage non ha ancora restituito le righe. Aggiorna tra qualche istante.
            <v-btn small text color="primary" @click="refreshRows">Aggiorna righe</v-btn>
        </v-alert>

        <div v-else class="eight-d-list mt-4">
            <v-card v-for="row in rows" :key="`${row.numero}-${row.riga}`" outlined class="eight-d-row">
                <v-card-text class="d-flex flex-column flex-sm-row align-sm-center py-3">
                    <div class="flex-grow-1 min-width-0">
                        <div class="d-flex align-center flex-wrap">
                            <strong class="mr-2">{{ row.articolo }}</strong>
                            <v-chip
                                x-small
                                :color="row.eight_d_available ? 'green lighten-3' : 'orange lighten-4'"
                            >
                                {{ row.status_8d }}
                            </v-chip>
                        </div>
                        <div class="caption grey--text text--darken-1 text-truncate">
                            Riga {{ row.riga }}<span v-if="row.descrizione"> · {{ row.descrizione }}</span>
                        </div>
                    </div>
                    <nc-edit
                        :input="ncInput(row)"
                        :articolo="row.articolo"
                        :getdata="refreshRows"
                        :button-label="row.eight_d_available ? 'Apri o modifica 8D' : 'Compila 8D'"
                        :button-color="row.eight_d_available ? 'success' : 'primary'"
                        class="mt-3 mt-sm-0"
                        @saved="refreshRows"
                    />
                </v-card-text>
            </v-card>
        </div>
    </section>
</template>

<script>
import NcEdit from "./NcEdit.vue";

export default {
    name: "MailSegnalazioneEightD",
    components: { NcEdit },
    props: {
        ncNumber: { type: [String, Number], required: true },
        rows: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        errorMessage: { type: String, default: "" },
    },
    computed: {
        completedCount() {
            return this.rows.filter((row) => row.eight_d_available).length;
        },
    },
    methods: {
        ncInput(row) {
            return {
                ...row,
                "8d_disponibile": row.eight_d_available,
            };
        },
        refreshRows() {
            this.$emit("refresh");
        },
    },
};
</script>

<style scoped>
.review-section { padding: 20px 0; }
.section-heading { display: flex; justify-content: space-between; align-items: center; gap: 16px; }
.eight-d-list { display: grid; gap: 8px; }
.eight-d-row { border-left: 4px solid var(--v-primary-base) !important; }
.min-width-0 { min-width: 0; }
@media (max-width: 599px) {
    .section-heading { align-items: flex-start; flex-direction: column; gap: 8px; }
}
</style>
